import { Lead } from "../types/lead";
import { LeadsPro } from "./LeadsPro";

interface RequestedLeadsProps {
  leads: Lead[];
  onViewDetails: (leadId: string) => void;
  onAcceptLead?: (leadId: string) => void;
  onDeclineLead?: (leadId: string) => void;
  canRespondToJobs?: boolean;
  canAcceptJobs?: boolean;
}

export function RequestedLeads({ onAcceptLead, ...props }: RequestedLeadsProps) {
  return <LeadsPro {...props} requested onApplyLead={onAcceptLead} />;
}
